function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';

var DetectedCountry = /*#__PURE__*/function () {
  function DetectedCountry() {
    _classCallCheck(this, DetectedCountry);
  }

  _createClass(DetectedCountry, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-detected-country', {
        template: "\n      <div v-if=\"country\" class=\"detected-country\">\n        <h4>{{labels.detectedCountryHeadline}}</h4>\n        <div class=\"country grid-x\">\n          <div class=\"cell medium-5\">\n            <a v-if=\"country.link && country.link.length > 0\" :href=\"country.link\"><i :class=\"'flag-icon flag-icon-'+country.code+' flag-icon-round'\"></i> <span>{{country.name}}</span></a>\n            <span v-else><i v-if=\"country.code && country.code.length > 0\" :class=\"'flag-icon flag-icon-'+country.code+' flag-icon-round'\"></i> <span>{{country.name}}</span></span>\n          </div>\n        </div>\n        <div class=\"grid-x\">\n          <div class=\"alert-message attention cell medium-10\" role=\"alert\">\n            {{ message }}\n          </div>\n        </div>\n      </div>",
        props: ['labels'],
        computed: {
          country: function country() {
            return window.detectedCountry;
          },
          message: function message() {
            if (this.country && this.country.link) {
              return this.labels.siteFound.replace('%s', this.country.name);
            }

            return this.labels.noSiteFound;
          }
        }
      });
    }
  }]);

  return DetectedCountry;
}();

export default DetectedCountry;